// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WXtD","col":"styles_col__1efFZ"};